export default "__VITE_ASSET__CqxoVGrI__"